import React from "react";

const ContactInfoSection: React.FC = () => {
  return (
    <section className="contact pt-120 pb-150">
      <div className="container">
        {/* Title Row */}
        <div className="row mb-60">
          <div className="col-12">
            <div className="sec-title sec-title-center about-sec-title about-sec-title-two">
              <span className="sub-title mb-10">Get In Touch</span>
              <h2 className="title">
                Let's Get In Touch
              </h2>
            </div>
          </div>
        </div>

        {/* Info Columns */}
        <div className="row">
          {/* Phone */}
          <div className="col-lg-4 col-md-6 mb-40">
            <div className="contact-info-block text-center d-flex flex-column align-items-center">
              <div 
                className="icon-box" 
                style={{ 
                  width: "60px", 
                  height: "60px", 
                  border: "1px solid rgba(255, 255, 255, 0.2)", 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "center", 
                  marginBottom: "25px",
                  color: "#fff",
                  borderRadius: "50%"
                }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
              </div>
              <p className="contact-text mb-0" style={{ fontSize: "20px", color: "rgba(255, 255, 255, 0.8)", marginBottom: "8px" }}>
                +1 437 447 5333
              </p>
            </div>
          </div>

          {/* Email */}
          <div className="col-lg-4 col-md-6 mb-40">
            <div className="contact-info-block text-center d-flex flex-column align-items-center">
              <div 
                className="icon-box" 
                style={{ 
                  width: "60px", 
                  height: "60px", 
                  border: "1px solid rgba(255, 255, 255, 0.2)", 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "center", 
                  marginBottom: "25px",
                  color: "#fff",
                  borderRadius: "50%"
                }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
              <p className="contact-text mb-0" style={{ fontSize: "20px", color: "rgba(255, 255, 255, 0.8)", marginBottom: "8px" }}>
                info@torqai.ca
              </p>
            </div>
          </div>

          {/* Location */}
          <div className="col-lg-4 col-md-6 mb-40">
            <div className="contact-info-block text-center d-flex flex-column align-items-center">
              <div 
                className="icon-box" 
                style={{ 
                  width: "60px", 
                  height: "60px", 
                  border: "1px solid rgba(255, 255, 255, 0.2)", 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "center", 
                  marginBottom: "25px",
                  color: "#fff",
                  borderRadius: "50%"
                }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
              </div>
              <p className="contact-text mb-0" style={{ fontSize: "20px", color: "rgba(255, 255, 255, 0.8)" }}>
                30 Charles St W<br/>Toronto, ON
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactInfoSection;
